module.exports = __webpack_public_path__ + "static/media/mehwash_logo.a66d713d.png";